import axios from "axios"
import { create } from "zustand"

export let useAudioCat = create((set, get) => ({
    cats: [],
    columns: [
        {
            title: "ID",
            dataIndex: "id",
            key: "id",
            width: 50,
        },
        {
            title: "Nomi",
            dataIndex: "name",
            key: "name",
        },
    ],
    ed: {},
    setEd: (ed) => set({ ed }),
    setCats: () => {
        axios.get('/audio-categories')
            .then((res) => {
                const data = Array.isArray(res.data) ? res.data : [];
                set({ cats: data });
            })
            .catch((err) => {
                console.error('Audio kategoriyalarini yuklab olishda xatolik:', err);
                set({ cats: [] });
            })
    },
    addCat: (cat) => {
        axios.post('/audio-categories', cat)
            .then((res) => {
                get().setCats();
            })
            .catch((err) => {
                console.error('Audio kategoriyasi qo\'shishda xatolik:', err);
            })
    },  
    editCat: (cat) => {
        axios.put('/audio-categories/' + cat.id, cat)
            .then((res) => {
                get().setCats();
            })
            .catch((err) => {
                console.error('Audio kategoriyasini taxrirlashda xatolik:', err);
            })
    },
    delCat: (id) => {
        axios.delete('/audio-categories/' + id)
            .then((res) => {
                get().setCats();
            })
            .catch((err) => {
                console.error('Audio kategoriyasini o\'chirishda xatolik:', err);
            })
    }
}))